module.exports = __webpack_public_path__ + "static/media/login_bg.a6b40b30.png";